/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Trans } from "react-i18next";

class Survey extends Component {
  convertTurkishChar = (str) => {
    return str
      .replaceAll("İ", "I")
      .replaceAll("ı", "i")
      .replaceAll("Ü", "U")
      .replaceAll("ü", "u")
      .replaceAll("Ö", "O")
      .replaceAll("ö", "o")
      .replaceAll("Ğ", "G")
      .replaceAll("ğ", "g")
      .replaceAll("Ş", "S")
      .replaceAll("ş", "s")
      .replaceAll("Ç", "C")
      .replaceAll("ç", "c");
  };

  handleDetailClick = (survey, fullname) => {
    const arr = fullname.split(" ");
    const firstName = arr[0];
    const lastName = arr.length > 1 ? arr[1] : "";
    this.renderSurvey(
      firstName,
      lastName,
      survey.inviteId,
      survey.surveyIdentifier
    );
  };

  renderSurvey = (FirstName, LastName, InviteId, identifierId) => {
    var se = new window.SurveyEmbed(
      identifierId,
      "https://forms.office.com/",
      "https://mfpembedcdnweu.azureedge.net/mfpembedcontweu/",
      "true"
    );
    let context = {
      "First Name": this.convertTurkishChar(FirstName),
      "Last Name": this.convertTurkishChar(LastName),
      InviteId: InviteId,
    };

    se.renderPopup(context);
  };

  render() {
    const { survey } = this.props;
    return (
      <>
        <tr>
          <td className="showGrup">{survey.survey.name}</td>
          <td className="showGrup">{survey.subject}</td>
          <td className="showGrup">
            <a
              href="#"
              data-toggle="modal"
              data-target="#duyuruModal"
              className="btn btn-fga-view"
              onClick={() =>
                this.handleDetailClick(survey, this.props.fullname)
              }
            >
              <Trans desc="Göster">10143</Trans>{" "}
              <span className="iconmford fo-icon-search" style={{ fontSize: 0 }}></span>
            </a>
          </td>
        </tr>
      </>
    );
  }
}

export default Survey;
